export const GET_ALL_CUSTOMER_DATA = 'GET_ALL_CUSTOMER_DATA';
